import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

import { computed } from "vue";
import type { TableDataCell } from "@/models/interfaces/entity-settings/querytable/querytable";
import { formatChangeDateRows } from "./cellFormat";


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeDateCellElementLite',
  props: {
    element: {}
  },
  setup(__props: any) {

const props = __props;
const rows = computed(() => formatChangeDateRows(props.element));

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (text, i) => {
    return (_openBlock(), _createElementBlock("div", {
      key: i,
      class: _normalizeClass(["qtl-change-date", { 'qtl-change-date--grey': _ctx.element.DisplayType === 6 }])
    }, _toDisplayString(text), 3))
  }), 128))
}
}

})